export class ShowViewerArgs {
    show: boolean = true;
    itemId: string;
    itemType: string;
    variantId: string;
    subType: string;

    constructor(show,
        itemId,
        itemType,
        variantId,
        subType = null) {
            this.show = show;
            this.itemId = itemId;
            this.itemType = itemType;
            this.variantId = variantId;
            this.subType = subType;
    }
}